export default "__VITE_PUBLIC_ASSET__a4f7d473__"